import React, { PropTypes } from 'react';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput } from '../../Form';
import { inject, observer } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import moment from "moment/moment";
import { token } from '../../../libs/localStorage';
import FormMultiSelectInput from "../../FormMultiSelectInput";

@inject('workOrderStore', 'workOrderStatusStore', 'priorityStore', 'maintenanceTypeStore', 'userStore', 'inventoryItemStore', 'ticketStore', 'stationStore')
@observer
class WorkOrderAdd extends React.Component {
  @observable multiStationOptions = [];
  @observable multiTicketOptions = [];

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = this.props.slug ? '/' + this.props.slug : '/monitoring/work_order/tabular';
  // slug = this.props.params.work_order_id ? `/station/${this.props.params.id}/maintenance/work_order/${this.props.params.work_order_id}/view/tasks` : `/monitoring/work_order/tabular/${this.props.params.id}/view/tasks`
  title = 'Add Work Order';

  @observable item = {
    title: '',
    priority_id: null,
    maintenance_type: null,
    completion_deadline: moment().add(1, 'week').format('YYYY-MM-DD'),
    creation_date: moment().format('YYYY-MM-DD'),
    scheduled_date: moment().format('YYYY-MM-DD'),
    created_by: +token.getDecoded().id,
    assigned_to: null,
    status_id: null,
  };

  @action onChangeTitle = e => this.item.title = e.target.value;
  @action onChangePriority = e => this.item.priority_id = +e.target.value;
  @action onChangeMaintenanceType = e => this.item.maintenance_type = +e.target.value;
  @action onChangeCompletionDeadline = e => this.item.completion_deadline = e.target.value;
  @action onChangeScheduledDate = e => this.item.scheduled_date = e.target.value;
  @action onChangeCreationDate = e => this.item.creation_date = e.target.value;
  @action onChangeAssignedTo = e => this.item.assigned_to = +e.target.value;
  @action onChangeStatus = e => this.item.status_id = +e.target.value;

  @action
  componentDidMount() {
    const { stationStore, ticketStore, location, params } = this.props;

    // stationStore.fetchItems().then(() => {
    this.multiStationOptions = this.props.stationStore.items.map(item => ({
      id: item.id,
      name: item.name,
      label: item.name,
      value: location && location.query && location.query.station_id ? +item.id === +location.query.station_id : params.id ? +item.id === +params.id : false,
      tags: item.tags,
    }));
    // });

    ticketStore.fetchItems().then(() => {
      this.multiTicketOptions = this.props.ticketStore.items.filter(t => !t.archived).map(item => ({
        id: item.id,
        station_id: item.station_id,
        name: item.summary,
        label: item.summary ? item.summary.toString() : item.id.toString(),
        value: location && location.query && location.query.ticket_id ? +item.id === +location.query.ticket_id : false
      }));
    });
  }

  handleSave = e => {
    e.preventDefault();

    const { workOrderStore } = this.props;
    const { notify } = this.context;

    // console.log(toJS(this.item))
    if (!this.item.priority_id || !this.item.maintenance_type || !this.item.status_id || !this.item.title || !this.item.assigned_to) {
      notify.error({ message: 'missing fields' });
      return;
    }

    const { priority_id, status_id, ...others } = this.item;
    const payload = { ...others, priority: priority_id, status: status_id };

    workOrderStore.createItem({
      ...payload,
      stations: this.multiStationOptions.filter(s => s.value).map(s => +s.id),
      tickets: this.multiTicketOptions.filter(t => t.value).map(t => +t.id),
    })
      .then(() => {
        notify.success({ message: 'Success' });
        workOrderStore.fetchItems()
        this.context.router.push(this.slug);
      })
      .catch(err => {
        console.log(err)
        notify.error(err);
        this.context.router.push(this.slug);
      });
  };

  @action onStationSelect = (item) => {
    item.value = !item.value;
    this.multiTicketOptions.filter(t => +t.station_id === +item.id).forEach(t => t.value = false);
  }

  @action
  onTicketSelect = (item) => {
    item.value = !item.value;
  }

  render() {
    const { workOrderStore, workOrderStatusStore, priorityStore, maintenanceTypeStore, userStore, ticketStore, stationStore, station_id } = this.props;
    const selectedMultiStations = this.multiStationOptions.filter(s => s.value).map(s => +s.id);

    return (
      <Modal slug={this.slug} title={this.title} isSaving={workOrderStore.isSaving}>
        <Form>
          <FormBody>
            <TextInput label={"Title"} onChange={this.onChangeTitle} value={this.item.title} />
            {station_id ?
              <TextInput label={"Station"} value={stationStore.findById(station_id).name} readOnly /> :
              <FormMultiSelectInput id='wo-add-station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onStationSelect} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />}
            <FormMultiSelectInput id='ticket-multi-select' label='Related Tickets' options={this.multiTicketOptions.filter(ticket => selectedMultiStations.includes(+ticket.station_id))} optionClicked={item => this.onTicketSelect(item)} isLoading={ticketStore.isLoading} />
            <SelectInput label='Priority' options={priorityStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.priority_id} onChange={this.onChangePriority} />
            <SelectInput label='Maintenance Type' options={maintenanceTypeStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.maintenance_type} onChange={this.onChangeMaintenanceType} />
            <SelectInput label='Status' options={workOrderStatusStore.items} fields={{ value: 'id', label: 'caption' }} value={this.item.status_id} onChange={this.onChangeStatus} />
            <SelectInput label='Assigned To' options={userStore.items} fields={{ value: 'id', label: 'name' }} value={this.item.assigned_to} onChange={this.onChangeAssignedTo} />
            <DateInput label='Creation Date' value={this.item.creation_date} onChange={this.onChangeCreationDate} />
            <DateInput label='Completion Deadline' value={this.item.completion_deadline} onChange={this.onChangeCompletionDeadline} />
            <DateInput label='Scheduled Date' value={this.item.scheduled_date} onChange={this.onChangeScheduledDate} />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default WorkOrderAdd;



// WEBPACK FOOTER //
// ./src/components/Maintenance/WorkOrder/WorkOrderAdd.js